import { PureComponent } from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { useFela } from 'react-fela';
import Empty from 'antd/lib/empty';
import { defaults as _defaults, isEqual as _isEqual } from 'lodash';

import rule from './sortable.rule';

import * as actions from '../services/actions';
import { selectSortablePool } from '../services/selectors';

export default (options = {}) =>
    Component => {
        _defaults(options, {
            enableReinitialize: true,
            showNoData: true,
            settings: {},
        });

        _defaults(options.settings, {
            distance: 1,
            axis: 'xy',
        });

        // eslint-disable-next-line new-cap
        const SortableItem = SortableElement(({ value }) => <Component {...value} />);

        // eslint-disable-next-line new-cap
        const SortableList = SortableContainer(({ items }) => {
            const { css } = useFela();

            return (
                <div className={css(rule)}>
                    {items.map((value, index) => (
                        <SortableItem key={value.id || value.uid} index={index} value={value} />
                    ))}
                    {!items.length && options.showNoData && <Empty />}
                </div>
            );
        });

        class List extends PureComponent {
            componentDidMount() {
                this.props.createPool(this.props.initialItems);
            }
            componentDidUpdate(props) {
                // TODO: there is some problem with reference equality, maybe seletors returning a non memoized values?
                if (!_isEqual(this.props.initialItems, props.initialItems) && options.enableReinitialize) {
                    this.props.createPool(this.props.initialItems);
                }
            }
            componentWillUnmount() {
                this.props.deletePool();
            }
            render() {
                const { items, handleSort } = this.props;
                return <SortableList {...options.settings} items={items} onSortEnd={handleSort} />;
            }
        }

        List.propTypes = {
            id: PropTypes.string.isRequired,

            initialItems: PropTypes.arrayOf(options.shape),
            items: PropTypes.arrayOf(options.shape).isRequired,
            handleSort: PropTypes.func.isRequired,

            createPool: PropTypes.func.isRequired,
            deletePool: PropTypes.func.isRequired,
        };

        List.defaultProps = {
            initialItems: [],
            onSortEnd: () => {},
        };

        return connect(
            (state, { id }) => ({
                items: selectSortablePool(state, { id }),
            }),
            (dispatch, { onSortEnd, id }) => ({
                createPool: items => {
                    dispatch(actions.createPool(id, items));
                },
                deletePool: () => {
                    dispatch(actions.deletePool(id));
                },
                handleSort: info => {
                    if (info.oldIndex !== info.newIndex) {
                        dispatch(actions.sortPool(id, info));
                        onSortEnd(info);
                    }
                },
            }),
        )(List);
    };
